import React from "react";
import PropTypes from "prop-types";
import "./TransactionProcessing.style.scss";
import {_t} from "../../../../../../utils/I18nUtils";

const TransactionProcessing = ({ vm, style})=>{

    return <div className="TransactionProcessing" style={style}>
        <h2 className="text-center">{_t(`views.addFundsView.skrill.transactionProcessing.title`)}</h2>
        <br/>
        <p className="text-center">{_t(`views.addFundsView.skrill.transactionProcessing.content`)}</p>

        <div className="buttonsBar">
            {vm.sessionId && <button
                                  onClick={e => vm.openTransactionWindow()}
                                  className="btn btn-primary btn-md reOpenLink">{
                _t("views.addFundsView.skrill.transactionProcessing.reOpenLinkLabel")
            }</button>}
        </div>
    </div>
};

TransactionProcessing.propTypes = {
    vm: PropTypes.object,
};

export default TransactionProcessing;